import { TRateCardModifierSet, TRateCardModifierType, TRateCardRules } from '@types';

export const DEFAULT_MODIFIER_SET: TRateCardModifierSet = {
	pallet_jack: {
		type: TRateCardModifierType.FIXED,
		value: '0'
	},
	/*
	   forklift: {
	   	type: TRateCardModifierType.FIXED,
	   	value: '0'
	   },
	   not_moveable_by_forklift: {
	   	type: TRateCardModifierType.FIXED,
	   	value: '0'
	   }, */
	pallet_exchange: {
		type: TRateCardModifierType.FIXED,
		value: '0'
	},
	pallet_transfer: {
		type: TRateCardModifierType.FIXED,
		value: '0'
	},
	tailgate_lift: null,
	day_surcharges: {
		saturday: null,
		sunday: null,
		public_holiday: null,
	},
	time_slot: null,
	hand_unload: null,
	split_trailer: null,
	truck_type: {
		details: {
			TIPPER: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			TAUTLINER: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			TAUTLINER_DROP_DECK: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			TAUTLINER_MEZZANINE_DECK: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			TAUTLINER_STRAIGHT_DECK: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			PANTECH: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			FLAT_TOP: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			SIDELOADER: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			SKELETON_TRAILER: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			OPEN_TOP: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
			UTE: {
				type: TRateCardModifierType.FIXED,
				value: '0'
			},
		},
	},
	tolls: {
		type: TRateCardModifierType.FIXED,
		value: '0'
	},
	admin_fee: {
		type: TRateCardModifierType.FIXED,
		value: '0'
	},
	/* fuel_levy_adjustment: {
	   	type: TRateCardModifierType.FIXED,
	   	value: '0'
	   },
	   express: {
	   	type: TRateCardModifierType.FIXED,
	   	value: '0'
	   },
	   demurrage: null, */
	additional_pickup_stops: null,
	additional_drop_off_stops: null,
	dangerous_goods: null,
	admin_standard_booking_fee: {
		type: TRateCardModifierType.FIXED,
		value: '0'

	}
}

export const DEFAULT_RULES: TRateCardRules = {
	allow_weekend: false,
	book_start_at_days: 1,
	max_future_book_at_days: 30,
	allow_pickup_stops: false,
	allow_consolidation: false,
	allow_address_change: false,
	min_drop_at_days: 1,
	booking_cutoff: '11:00',
	cpk_config_base_price: null,
	min_charge: '0',
	cpk_config_cubic_conversion: null,
	cpk_config_pallet_height: null,
	cpk_config_pallet_width: null,
	cpk_config_pallet_length: null,
	disable_take_now_price: false,
}